import React from 'react';
import CalendarIcon from 'hudl-react-kickoff/icons/Calendar';
import LocalizedMessage from 'common/localized-message';

const CoachNoEventsMessage = (props) => {
  return (
    <div className="tab-blank-state">
      <div>
        <LocalizedMessage id="profiles.team.update_schedule" values={{name: props.userLastName}}/>
      </div>
      <CalendarIcon className="calendar-icon blank-icon"/>
    </div>
  );
};

CoachNoEventsMessage.propTypes = {
  manageScheduleUrl: React.PropTypes.string.isRequired,
  seasonId: React.PropTypes.string.isRequired,
  userLastName: React.PropTypes.string.isRequired,
};

export default CoachNoEventsMessage;
